/* <cr-marquee>: keeps the announcement loop seamless when there are few messages, and pauses on the
   selected message in the Theme Editor. Animation itself is pure CSS (mockup css:56-60). */
if (!customElements.get('cr-marquee')) {
  customElements.define('cr-marquee', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.cr-announce');
      this.groups = this.querySelectorAll('.cr-announce__group');
      this.fill = this.fill.bind(this);
      this.fill();
      window.addEventListener('resize', this.fill, { passive: true });
      if (window.Shopify && window.Shopify.designMode) {
        this.onSelect = (e) => { if (this.contains(e.target)) this.bar.classList.add('is-paused'); };
        this.onDeselect = (e) => { if (this.contains(e.target)) this.bar.classList.remove('is-paused'); };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.fill);
      if (this.onSelect) {
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }
    }

    // Each group must be at least as wide as the bar, otherwise a gap shows before the loop restarts.
    fill() {
      if (!this.groups.length || !this.bar) return;
      const original = Array.from(this.groups[0].children).map((n) => n.cloneNode(true));
      if (!original.length) return;
      let guard = 0;
      while (this.groups[0].scrollWidth < this.bar.clientWidth && guard < 10) {
        this.groups.forEach((g) => original.forEach((n) => g.appendChild(n.cloneNode(true))));
        guard++;
      }
    }
  });
}
